import { Link } from 'react-router-dom';
import './Errors.scss';
import { AppId, ProductLogo } from "@datassential/platform-ui-lib";

const ErrorPage = () => (
    <div className="error-page">
        <div className="error-page__inner">
            <div className="error-page__content">
                <ProductLogo appId={AppId.Snap} type="regular" className="error-page__logo"/>
                <p className="error-page__title">Page not found</p>
                <p className="error-page__text">The page you are looking for was moved, renamed or might never existed</p>
                <Link
                    to={'/'}
                    className="error-page__home-link"
                >
                    back to home page
                </Link>
            </div>
        </div>
    </div>
);

export default ErrorPage;
